import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bulltine',
  templateUrl: './bulltine.component.html',
  styleUrls: ['./bulltine.component.css']
})
export class BulltineComponent implements OnInit {
  currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
  objArr = [];
  loading = false
  arr = [1, 2, 3]
  website
  reg = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/

  constructor(private authService: AuthservicesService,private router:Router) { }

  ngOnInit(): void {
    this.getBulltin()
  }


  getBulltin() {
    this.authService.getBulltin(this.currentUser.id).subscribe((res: any) => {
      this.loading = true
      this.objArr = res.data
    },
      error => {
        console.log(error)
      })
  }



  deleteBulletin(id) {
    let swall = this.authService.swal('delete')
    swall.then((result) => {
      if (result.value == true) {
        this.authService.removeBulltin(id).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success').then((res) => {
            if (res.value) this.getBulltin()
          })
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })

  }

  checkUrl(url) {
    this.website = ''
    let str = url
    let urlStatus = this.reg.test(str)
    if (urlStatus) {
      let res = str.includes('https://')
      if (res) { this.website = str }
      else if (!res) {
        this.website = `https://${str}`
      }
    }
    else if (!urlStatus) {
      this.website = ''
    }
    return this.website
  }


  getErrorImage(event) {
    this.authService.geterrorImage(event);
  }


  navigate(id) {
    this.router.navigate(['/bulletins/update-bulletine', id])
  }
}


